<template>
  <TransitionRoot as="template" :show="show">
    <Dialog as="div" class="fixed z-10 inset-0 overflow-y-auto">
      <div class="flex items-end justify-center min-h-screen text-center sm:block sm:p-0">
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
          <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>

        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
          <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full">
            <div class="bg-blue-200 text-left py-10 px-8 flex justify-between">
                <div class="mr-4"> <img src="@/assets/img/icons/viva-notif.png" width="80" class="inline"/>  </div>
                <div>
                  <p class="text-yellowGreen"> {{modalTranslation[language].updateBilling.important }}</p>
                  <DialogTitle as="h3" class="text-white text-3xl font-medium">
                    {{modalTranslation[language].updateBilling.title }}
                  </DialogTitle>
                </div>
            </div>
            <div class="px-8 py-2">
              <div class="w-full block text-left sm:mt-0">
                <div class="mt-8 text-left">
                  <p class="text-base">  {{modalTranslation[language].updateBilling.subtitle }} </p>
                </div>
              </div>
              <div class="px-4 py-6 mt-5 sm:px-6 sm:flex sm:flex-col justify-center">
                <button type="button" class="m-auto w-72 text-white inline-flex justify-center rounded-md shadow-sm px-8 py-4 bg-blue-100 text-base font-medium hover:bg-green-400 focus:outline-none focus:ring-green-400  hover:text-white" @click="goToPago">
                    {{modalTranslation[language].updateBilling.update }}
                </button>
                 <button type="button" class="m-auto  w-72 inline-flex justify-center rounded-md  px-8 py-4 text-base font-medium hover:bg-green-400 focus:outline-none hover:text-white mt-2" @click="closeModal">
                    {{modalTranslation[language].updateBilling.later }}
                </button>
              </div>
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { useRouter } from 'vue-router'
import { modalTranslation } from '@/translations/Modals.js'
import { computed } from '@vue/reactivity'

export default {
  props: ['show'],
  setup(props, { emit }){
        const router = useRouter()
        const goToPago = () =>{
            router.push({ name : 'DashboardPago' })
        }

          const language = computed( ()=> {
                return  localStorage.getItem('viva-translate') ? localStorage.getItem('viva-translate') : 'es';
            })


        const closeModal = () =>{
            emit('close')
        }

        return { goToPago, closeModal, language, modalTranslation}

      
  },
  components: {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
  },
}
</script>